import {css} from '@yandex-delivery/blocks/theme/css'

const PIN_BOTTOM_OFFSET = 30

export const map = css`
  position: relative;
  inline-size: 100%;
`

export const pinIcon = css`
  inset-inline-start: 50%;
  position: absolute;
  inset-block-start: 50%;
  transform: translate(-50%, calc(-50% - ${PIN_BOTTOM_OFFSET}px));
  z-index: 1;
`
